import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { armadoEntregado } from "../../redux/documentos/documentosAction";
import { format } from "date-fns";
import { SlSocialDropbox } from "react-icons/sl"; //caja para no armado
import { BsFillBox2HeartFill } from "react-icons/bs"; //caja para armado
import { BsTruck } from "react-icons/bs";//camion no entregado
import { BsTruckFlatbed } from "react-icons/bs";//camion entregado

export default function DocumentoCard({id, numDocumento, nombre, cuitCuilDni, ciudad, direccion, cp, zona, telefono, fecha, armado:initialArmado, entregado:initialEntregado}) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [armado, setArmado] = useState(initialArmado);
    const [entregado, setEntregado] = useState(initialEntregado);
    const [armadoColor, setArmadoColor] = useState(initialArmado ? "#03f515" : "#f51503");
    const [entregadoColor, setEntregadoColor] = useState(initialEntregado ? "#03f515" : "#f51503");

    //console.log(armado, entregado);
    

    const handleLink = () => {
        navigate(`/documentoDetalle/${id}`)
    }

    useEffect(() => {
        setArmadoColor(initialArmado ? "#03f515" : "#f51503");
        setEntregadoColor(initialEntregado ? "#03f515" : "#f51503");
    }, [initialArmado, initialEntregado]);

    const handleArmadoEntregado = (e) => {
        e.stopPropagation(); // Detener la propagación del evento
        const { value } = e.currentTarget.dataset;
        console.log(value)
        if(value === "ARMADO" && armado === false && entregado === false){
            console.log("true")            
            setArmadoColor("#03f515");
            dispatch(armadoEntregado({
                id:id,
                armado: true,
                entregado: false
            }))
            setArmado(true)
            
        } else if(value === "ARMADO" && armado === true && entregado === false) {
            setArmadoColor("#f51503");
            console.log("false")            
            dispatch(armadoEntregado({
                id:id,
                armado: false,
                entregado: false
            }))
            setArmado(false)          
        }
        
        if(value === "ENTREGADO" && armado === true && entregado === false){
            console.log("entregado true")            
            setEntregadoColor("#03f515")
            dispatch(armadoEntregado({
                id:id,
                armado: true,
                entregado: true
            }))
            setEntregado(true)
             
        } else if(value === "ENTREGADO" && armado === true && entregado === true){
            console.log("entregado false") 
            setEntregadoColor("#f51503")           
            dispatch(armadoEntregado({
                id:id,
                armado: true,
                entregado: false
            }))
            setEntregado(false) 
        }
        
    } 

    return(
        <>
            <table>
                <tbody>
                <tr className="text-sky-300 text-[10pt] font-semibold border-b border-slate-400 hover:font-bold hover:text-yellow-300 cursor-pointer"
                    onClick={handleLink}
                >                
                    <td className="text-[7pt] w-[60px] text-center md:w-[90px] md:text-[11pt]">{format(new Date(fecha), 'dd/MM/yyyy')}</td> 
                    <td className="text-[8pt] w-[55px] text-center md:w-[80px] md:text-[11pt]">{numDocumento}</td>
                    <td className="text-[8pt] w-[150px] md:w-[300px] md:text-[11pt]">{nombre}</td>
                    <td className="text-[8pt] w-[91px] text-center hidden sm:flex md:pl-3 md:w-[100px] md:text-[11pt]">{cuitCuilDni}</td>
                    <td className="text-[8pt] w-[91px] md:w-[150px] md:text-[11pt]">{ciudad}</td>
                    <td className="text-[8pt] w-[110px] md:w-[300px] md:text-[11pt]">{direccion}</td>
                    <td className="text-[8pt] hidden w-[50px] md:pl-3 md:flex md:pt-[6px] md:text-[11pt]">{cp}</td>
                    <td className="text-[8pt] md:text-[11pt] w-[45px] text-center">{zona}</td>
                    <td className="text-[8pt] hidden w-[110px]  md:pl-3 md:flex md:pt-[6px] md:text-[11pt]">{telefono}</td>
                    <td className="w-[40px] pl-5 md:w-[60px]">
                        <button className="h-[30px]" data-value="ARMADO" onClick={handleArmadoEntregado}>
                            {armado ? <BsFillBox2HeartFill style={{ color: armadoColor, width:"25px", height:"25px"  }} size="16px" /> : <SlSocialDropbox style={{ color: armadoColor, width:"25px", height:"25px"  }} size="16px" />}
                        </button>
                    </td>
                    <td className="w-[40px] pl-5 md:w-[60px]">
                        <button className="h-[30px]" data-value="ENTREGADO" onClick={handleArmadoEntregado}>
                            {entregado ? <BsTruckFlatbed style={{ color: entregadoColor, width:"25px", height:"25px" }} size="16px" /> : <BsTruck style={{ color: entregadoColor, width:"25px", height:"25px"  }} size="16px" />}
                        </button>
                    </td>
                </tr>                             
                </tbody>
            </table>
        </>
    )
}